import angular from 'angular'

import ConfirmModalController from './confirm.controller'
import confirmTemplate from './confirm.html'

/**
 * A confirm modal dialog, with a confirm and cancel button.
 *
 * @param {object} options The confirm options. Will also be passed to the modal and be exposed to the template as
 * `modalCtrl.options`.
 *
 * @param {String} options.header The dialog header.
 *
 * @param {html} options.content The dialog content.
 *
 * @param {String|Object} [options.confirm] The text of the confirm button or an object containing overriding
 *                                          properties. Defaults to 'Confirm'. See the Confirm controller.
 *
 * @param {String|Object} [options.cancel] The text of the cancel button or an object containing overriding properties.
 *                                         Defaults to 'Cancel'. See the Confirm controller.
 *
 * @return {promise} By default, resolves when the user clicks on the `confirm` button, rejects when the use clicks on
 * the `cancel` button, or if there was an error when opening the modal.
 *
 * @example
 * <script>
 *     function ConfirmDemoCtrl($scope, Confirm) {
 *         $scope.open = function() {
 *            Confirm({
 *                header: 'Do you want to launch Doomsday Machine?',
 *                content: 'Ready to end life on earth?',
 *                cancel: 'Nah...',
 *                confirm: 'Nuke!!!'
 *             })
 *         }
 *     }
 * </script>
 * <div ng-controller="ConfirmDemoCtrl">
 *     <button class="vd-btn vd-btn--do" ng-click="open()">Open confirm</button>
 *     <button class="vd-btn vd-btn--do" ng-click="openAsync()">Open async confirm</button>
 * </div>
 */
angular.module('vend.ui').factory('Confirm', function ($log, $q, Modal) {
  return function (options) {
    return $q((resolve, reject) => {
      options.template = confirmTemplate
      options.controller = ConfirmModalController
      options.controllerAs = '$ctrl'

      Modal(options)
        .then(modal => {
          modal.close
            .then(result => resolve(result))
            .catch(error => reject(error))
        })
        .catch(error => {
          // Error opening the modal
          $log.error(error)
          reject(error)
        })
    })
  }
})
